import { OctTable } from "@oceantech/oceantech-ui";
import {useContext, useEffect, useMemo, useState} from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import CustomIconButton from "../component/custom-icon-button/CustomIconButton";
import DatePickerCustom from "../component/date-picker/DatePickerCustom";
import LabelRequired from "../component/LabelRequired";
import TextValidator from "../component/TextValidator";
import { IConfigTable } from "../models/OctResponse";
import {
  BTN_ACTIONS,
  CODE_SUCCESS,
  INIT_SEARCH_OBJECT,
  TYPE,
} from "../utils/Constant";
import "./ReportEvaluation.scss";
import ReportDetailModal from "./modals/ReportDetailModal";
import { AppContext } from "../appContext/AppContext";
import {
  getDataReport,
  getListCriteria,
} from "./services/ReportEvaluation";
import { ISearchReports } from "./models/ReportEvaluationModels";
import ReportEvaluationColumns from "./columns";
import {ReportEvaluationProvider} from "./context/ReportEvaluationContext";

type Props = {};

const ReportEvaluation = (props: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const [objectSearch, setObjectSearch] = useState<ISearchReports>({
    ...INIT_SEARCH_OBJECT,
    pageSize: 20,
  });
  const [data, setData] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [itemDetail, setItemDetail] = useState<any>(null);
  const [configTable, setConfigTable] = useState<IConfigTable>({
    totalPages: 1,
    totalElements: 5,
    numberOfElements: 5,
  });
  const [showReportDetailModal, setShowReportDetailModal] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [dataChecked, setDataChecked] = useState<any[]>([]);
  const [showModalConfirm, setShowModalConfirm] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    handleGetListCriteria().then(r => r);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, objectSearch.pageIndex, objectSearch.pageSize]);

  const handleGetListCriteria = async () => {
    const params = {
      ...objectSearch,
      planId: objectSearch?.plan?.id,
      planName: objectSearch?.plan?.name,
    };
    delete params.plan;
    setIsLoading(true);
    try {
      const { data } = await getListCriteria(params);
      if (data?.code === CODE_SUCCESS) {
        setData(data?.data?.content);
        setConfigTable({
          totalPages: data?.data?.totalPages,
          totalElements: data?.data?.totalElements,
          numberOfElements: data?.data?.numberOfElements,
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenReportDetailModal = (type: string, criteria: any) => {
    setShowReportDetailModal(true);
    setIsView(type === BTN_ACTIONS.VIEW);
    setItemDetail(criteria);
  };

  const evaluateColumns = useMemo(() => ReportEvaluationColumns({
    handleOpenReportDetailModal,
  }), []);

  const handleCloseCriteriaModal = () => {
    setShowReportDetailModal(false);
    setIsView(false);
    setReload(!reload);
    setItemDetail(null);
  }

  const handleChange = (name: string, value: any) => {
    setObjectSearch({
      ...objectSearch,
      [name]: value,
    });
  };

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSubmitSearch();
    }
  };

  const handleSubmitSearch = () => {
    setReload(!reload);
    setObjectSearch({
      ...objectSearch,
      pageIndex: 1,
    });
  };

  const contextValue = useMemo(() => ({
    isView,
    itemDetail,
    setItemDetail,
  }), [itemDetail, isView]);

  return (
    <div className="pe-list">
      <ReportEvaluationProvider value={contextValue}>
        <div className="h-100 bg-white">
          <div className="reception-list__container spaces py-0">
            <div className="px-3 pt-2 border-bottom">
              <div className="text-title">Danh sách kế hoạch</div>
            </div>

            <div className="d-flex justify-content-between align-items-center px-3 pt-2">
              <div className="d-flex spaces mx-10 align-items-end">
                <LabelRequired className="max-content-width spaces mr-5" label="Từ ngày"/>
                <DatePickerCustom
                  placeholderText="dd/mm/yyyy"
                  name="startDate"
                  value={objectSearch?.startDate ?? ""}
                  setDateValue={(date) => {
                    handleChange("startDate", date);
                  }}
                  dateFormatOutput="YYYY-MM-DD"
                />
              </div>
              <div className="d-flex spaces mx-10 align-items-end">
                <LabelRequired className="max-content-width spaces mr-5" label="Đến ngày"/>
                <DatePickerCustom
                  placeholderText="dd/mm/yyyy"
                  name="endDate"
                  value={objectSearch?.endDate ?? ""}
                  setDateValue={(date) => {
                    handleChange("endDate", date);
                  }}
                  dateFormatOutput="YYYY-MM-DD"
                />
              </div>
              <div className="text-lable-input mb-0 spaces spaces mt-5 mr-5 form-label max-content-width">Từ khóa</div>
              <div className="flex-grow-1">
                <InputGroup className="spaces h-29 px-0">
                  <TextValidator
                    className="spaces h-29 min-w-200 rounded-end-0"
                    name="keyword"
                    placeholder="Tìm kiếm theo mã, tên kế hoạch"
                    value={objectSearch?.keyword || ""}
                    onChange={(e: any) =>
                      handleChange("keyword", e.target.value)
                    }
                    onKeyDown={handleKeyPress}
                  />
                  <Button
                    className="btn-fill spaces h-29"
                    onClick={handleSubmitSearch}
                  >
                    <i className="bi bi-search"></i>
                    <span>Lọc</span>
                  </Button>
                </InputGroup>
              </div>
            </div>

            <OctTable
              id="searchCriteria"
              className={`mt-7 table-background-th width-100 spaces h-calc-vh-230`}
              data={data}
              columns={evaluateColumns}
              searchObject={objectSearch}
              setSearchObject={setObjectSearch}
              fixedColumnsCount={-1}
              noToolbar={true}
              totalPages={configTable.totalPages}
              totalElements={configTable.totalElements}
              numberOfElements={configTable.numberOfElements}
              // handleDoubleClick={handleDoubleClick}
              isShowSelection={false}
              clearToolbar={true}
              type={TYPE.MULTILINE}
              setDataChecked={(dataChecked) => setDataChecked(dataChecked)}
            />
          </div>
        </div>

        {showReportDetailModal && (
          <ReportDetailModal
            show={showReportDetailModal}
            handleCloseDialog={handleCloseCriteriaModal}
          />
        )}
      </ReportEvaluationProvider>
    </div>
  );
};

export default ReportEvaluation;
